import axios from "axios"

export const getDictionaries = ({ locale }) => axios.get(`/api/main/dictionary/getDictionaries?language=${locale}`)
